import React, { lazy, useRef, useState } from "react";

/** Common Components */
import CardSection from "../../components/ui/card/CardSection";
import CenterModal from "../../components/ui/centerModal/CenterModal";

/** Report Types Page Styling */
import "./ReportTypes.scss";

/** Lazily Loaded Components */
const ReportTypesList = lazy(() =>
  import("./components/reportTypesList/ReportTypesList")
);
const AddEditReportType = lazy(() =>
  import("./components/addEditReportType/AddEditReportType")
);

const ReportTypes = () => {
  const molGridRef = useRef();

  const [isEdit, setIsEdit] = useState(false);
  const [editReportTypeData, setEditReportTypeData] = useState(null);
  const [isReportTypeModelOpen, setIsReportTypeModelOpen] = useState(false);

  const handleAddReportTypeClick = () => {
    setIsEdit(false);
    setEditReportTypeData(null);
    setIsReportTypeModelOpen(true);
  };

  const handleCloseModel = () => {
    setIsEdit(false);
    setEditReportTypeData(null);
    setIsReportTypeModelOpen(false);
  };

  const handleEditClick = (data) => {
    setIsEdit(true);
    setEditReportTypeData(data);
    setIsReportTypeModelOpen(true);
  };

  const handleSuccess = () => {
    handleCloseModel();
    if (molGridRef.current) {
      molGridRef.current?.refreshGrid();
    }
  };

  return (
    <>
      <div className="report-types">
        <CardSection
          cardTitle={"Report Types"}
          rightButton={true}
          buttonClassName={"blue-btn"}
          titleButtonClick={handleAddReportTypeClick}
          buttonText={"ADD"}
          searchInput={false}
          isButtonVisible={true}
          isButtonLoading={""}
          isIcon={true}
          iconClass="uil:plus"
        >
          <div className="only-list-body-scroll">
          <ReportTypesList ref={molGridRef} onEdit={handleEditClick} />
          </div>
        </CardSection>
      </div>
      <CenterModal
        modalTitle={isEdit ? `Update Report Type` : `Add Report Type`}
        modalSize={"w-50"}
        isOpen={isReportTypeModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
      >
        <AddEditReportType
          isEdit={isEdit}
          isOpen={isReportTypeModelOpen}
          initData={editReportTypeData}
          onClose={handleCloseModel}
          onSuccess={handleSuccess}
        />
      </CenterModal>
    </>
  );
};

export default ReportTypes;
